//import '../styles/fonts.scss';
import '../styles/bootstrap.scss';
import '../styles/global.scss';
import '../styles/atoms/typography.scss';
import '../styles/atoms/buttons.scss';
import '../styles/atoms/icons.scss';
import '../styles/components/site--user-menu.scss';
import '../styles/components/site--nav.scss';
import '../styles/components/site--minicart.scss';
import '../styles/components/site--footer.scss';
import '../styles/components/mylocker.scss';
import '../styles/components/mylocker--banner.scss';
import '../styles/components/mylocker--nav.scss';
import '../styles/components/mylocker--saved.scss';
import '../styles/components/mylocker--widget.scss';
import '../styles/components/pagedesigner--silhouette.scss';
import '../styles/components/pgp--grid.scss';
import '../styles/components/pgp--filters.scss';
import '../styles/components/pgp--tile.scss';
import '../styles/components/teamstore--store-elements.scss';
import '../styles/components/teamstore--grid.scss';
import '../styles/components/qv--product-select.scss';
import '../styles/components/pdp.scss';
import '../styles/components/pdp--bulkorder.scss';
import '../styles/components/pdp--recommender.scss';
import '../styles/components/pdp--expanded-gallery.scss';
// import 'bootstrap/js/dist/carousel';
import menu from './menu';
import checkbox from './checkbox';
import minicart from './minicart';
import pgp from './pgp';
import pdp from './pdp';
import teamstore from './teamstore';
import './svguse';

menu();
checkbox();
minicart();
pgp();
pdp();
teamstore();
